<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-snackbar v-model="ok_snackbar" :timeout="3000" color="green darken-3 white--text" :top="true">
        {{ ok_text }}
        <v-btn color="white" flat @click="ok_snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-snackbar v-model="error_snackbar" :timeout="3000" color="red darken-3 white--text" :top="true">
        {{ error_text }}
        <v-btn color="white" flat @click="error_snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialogDetail"
        persistent
        max-width="1200px"
        transition="dialog-transition"
        v-if="dialogDetail"
      >
        <v-card class="no__padding">
          <v-card-title class="pl-0">
            <h2>Spárovat platbu</h2>
          </v-card-title>
          <v-card color="grey lighten-4" class="pa-2 elevation-0">
            <v-card-text>
              <Loader v-if="searchingPair" skin="light" class="pt-5 pb-5"></Loader>
              <v-layout row wrap v-else>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md3>
                      <p class="grey--text caption mb-1">Datum a čas:</p> <strong>{{item.datum | formatDate}}</strong>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <p class="grey--text caption mb-1">Částka:</p> <strong>{{item.castka | formatMoney}} {{item.mena.zkratka}}</strong>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <p class="grey--text caption mb-1">Variabilní symbol:</p> <strong>{{item.variabilni_symbol}}</strong>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <p class="grey--text caption mb-1">Protiúčet:</p> <strong>{{item.protiucet}}/{{item.protiucet_kod}}</strong>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-3">
                    <v-flex xs12 sm6 md3>
                      <p class="grey--text caption mb-1">Název účtu:</p> <strong>{{item.bank_nazev_uctu}}</strong>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <p class="grey--text caption mb-1">Zpráva pro příjemce:</p> <strong>{{item.poznamka}}</strong>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-5">
                    <v-flex xs12>
                      <p><strong>Návrhy pro spárování:</strong></p>
                      <v-layout row wrap>
                        <v-flex xs12 sm3>
                          <osobasearch v-model="pairOsoba" label="Hledat osobu" :all="true"></osobasearch>
                        </v-flex>
                      </v-layout>
                      <v-data-table
                        :headers="pairHeaders"
                        :items="pairItems"
                        :pagination.sync="pagination"
                        :total-items="pagination.totalItems"
                        :rows-per-page-items="[25, 50, 100, 200]"
                        class="elevation-1"
                        item-key="id"
                        :loading="loadingTable"
                        ref="pairItemsTable"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <v-icon v-if="props.expanded" @click="props.expanded=false">expand_less</v-icon>
                            <v-icon v-else @click="props.expanded=true">expand_more</v-icon>
                          </td>
                          <td>
                            <router-link :to="{ path: '/klienti/'+props.item.id.toString() }" target="_blank">
                              <strong>{{ props.item.nazev_osoby }}</strong>
                            </router-link>
                          </td>
                          <td>
                            <div v-if="props.item.spolupracovnik==1">Spolupracovnik</div>
                            <div v-if="props.item.klient==1">Klient</div>
                          </td>
                          <td>
                            <div v-for="(d, i) in props.item.duvod" :key="'duvod-'+i.toString()">
                              <span v-if="d=='stejny_bankovni_ucet'">Stejný bankovní účet</span>
                              <span v-if="d=='stejny_variabilni_symbol'">Stejný variabilní symbol</span>
                            </div>
                          </td>
                        </template>
                        <template slot="expand" slot-scope="props">
                          <div class="ml-5 mt-3 mr-3 mb-3">
                            <p class="caption mt-2 mb-2" v-if="props.item.sporeni.length>0"><strong>Spoření</strong></p>
                            <v-data-table
                              :headers="pairHeadersSporeni"
                              :items="props.item.sporeni"
                              :pagination.sync="pagination"
                              :total-items="pagination.totalItems"
                              :rows-per-page-items="[25, 50, 100, 200]"
                              class="elevation-1 mt-0 mb-2"
                              item-key="id"
                              :loading="loadingTable"
                              color="grey"
                              v-if="props.item.sporeni.length>0"
                            >
                              <template slot="items" slot-scope="props">
                                <td><strong>{{ props.item.nazev_sporeni }}</strong></td>
                                <td><strong>{{ props.item.variabilni_symbol }}</strong></td>
                                <td>
                                  <strong v-if="props.item.stav_sporeni=='probiha'">Probíhá</strong>
                                </td>
                                <td><strong>{{ props.item.mena.nazev }}</strong></td>
                                <td class="text-xs-right">
                                  <v-btn color="primary" depressed small @click="makePair(props.item.osoba_id, 'sporeni', props.item.id)">Spárovat se spořením</v-btn>
                                </td>
                              </template>
                            </v-data-table>
                            <p class="caption mt-3" v-if="props.item.objednavky.length>0"><strong>Objednávky</strong></p>
                            <v-data-table
                              :headers="pairHeadersObjednavky"
                              :items="props.item.objednavky"
                              :pagination.sync="pagination"
                              :total-items="pagination.totalItems"
                              :rows-per-page-items="[25, 50, 100, 200]"
                              class="elevation-1 grey mb-2"
                              item-key="id"
                              :loading="loadingTable"
                              color="grey"
                              v-if="props.item.objednavky.length>0"
                            >
                              <template slot="items" slot-scope="props">
                                <td><strong>{{ props.item.cislo_objednavky }}</strong></td>
                                <td><strong>{{ props.item.castka_celkem | formatMoney }} {{ props.item.mena.zkratka }}</strong></td>
                                <td><strong>{{ props.item.stav_objednavky }}</strong></td>
                                <td class="text-xs-right">
                                  <v-btn color="primary" depressed small @click="makePair(props.item.osoba_id, 'objednavka', props.item.id)">Spárovat s objednávkou</v-btn>
                                </td>
                              </template>
                            </v-data-table>
                            <p class="caption mt-3" v-if="props.item.penezenky.length>0"><strong>Elektronická peněženka</strong></p>
                            <v-data-table
                              :headers="pairHeadersPenezenky"
                              :items="props.item.penezenky"
                              :pagination.sync="pagination"
                              :total-items="pagination.totalItems"
                              :rows-per-page-items="[25, 50, 100, 200]"
                              class="elevation-1 grey mb-2"
                              item-key="id"
                              :loading="loadingTable"
                              color="grey"
                              v-if="props.item.penezenky.length>0"
                            >
                              <template slot="items" slot-scope="props">
                                <td><strong>{{ props.item.mena.nazev }}</strong></td>
                                <td><strong>{{ props.item.aktualni_zustatek | formatMoney }} {{ props.item.mena.zkratka }}</strong></td>
                                <td class="text-xs-right">
                                  <v-btn color="primary" depressed small @click="makePair(props.item.osoba_id, 'penezenka', props.item.id)">Nahrát do peněženky</v-btn>
                                </td>
                              </template>
                            </v-data-table>
                          </div>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card-actions class="mt-3 pr-0">
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDetail=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogReturnPayment"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogReturnPayment"
      >
        <v-card class="no__padding">
          <v-card-title class="pl-0">
            <h2>Opravdu chcete vrátit tuto platbu?</h2>
          </v-card-title>
          <v-card color="grey lighten-4" class="pa-2 elevation-0">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Datum a čas:</p> <strong>{{item.datum | formatDate}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Částka:</p> <strong>{{item.castka | formatMoney}} {{item.mena.zkratka}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Variabilní symbol:</p> <strong>{{item.variabilni_symbol}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Protiúčet:</p> <strong>{{item.protiucet}}/{{item.protiucet_kod}}</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Název účtu:</p> <strong>{{item.bank_nazev_uctu}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <p class="grey--text caption mb-1">Zpráva pro příjemce:</p> <strong>{{item.poznamka}}</strong>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card-actions class="mt-3 pr-0">
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="returnPayment" :loading="returningPayment">Ano, vrátit platbu</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogReturnPayment=false" v-if="!returningPayment">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogRemovePayment"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogRemovePayment"
      >
        <v-card class="no__padding">
          <v-card-title class="pl-0">
            <h2>Opravdu chcete smazat tuto platbu?</h2>
          </v-card-title>
          <v-card color="grey lighten-4" class="pa-2 elevation-0">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Datum a čas:</p> <strong>{{item.datum | formatDate}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Částka:</p> <strong>{{item.castka | formatMoney}} {{item.mena.zkratka}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Variabilní symbol:</p> <strong>{{item.variabilni_symbol}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Protiúčet:</p> <strong>{{item.protiucet}}/{{item.protiucet_kod}}</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Název účtu:</p> <strong>{{item.bank_nazev_uctu}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <p class="grey--text caption mb-1">Zpráva pro příjemce:</p> <strong>{{item.poznamka}}</strong>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card-actions class="mt-3 pr-0">
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="removePayment" :loading="removingPayment">Ano, smazat platbu</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogRemovePayment=false" v-if="!removingPayment">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12>
                <h3>Bankovní výpis</h3>
              </v-flex>
            </v-layout>
            <v-btn-toggle :class="{'btn-toggle__mobile': $vuetify.breakpoint.xs}" v-model="stav_platby">
              <v-btn flat color="blue" depressed>
                Vše
              </v-btn>
              <v-btn flat color="blue" depressed>
                Pouze spárované
              </v-btn>
              <v-btn flat color="blue" depressed>
                Pouze nespárované
              </v-btn>
            </v-btn-toggle>
            <div class="table-border__radius elevation-1 mt-3">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td><span class="no_wrap">{{ props.item.datum  | formatDate }}</span></td>
                  <td class="text-xs-right"><span class="no_wrap">{{ props.item.castka | formatMoney }}&nbsp;{{props.item.mena.zkratka}}</span></td>
                  <td>{{ props.item.variabilni_symbol }}</td>
                  <td v-if="props.item.protiucet != null"><span class="no_wrap">{{ props.item.protiucet }}/{{props.item.protiucet_kod}}</span></td>
                  <td v-else>--</td>
                  <td v-if="props.item.poznamka != null">{{ props.item.poznamka }}</td>
                  <td v-else>--</td>
                  <td v-if="props.item.osoba != null">
                    <router-link :to="{ path: '/klienti/'+props.item.osoba.id }" target="_blank">{{ props.item.osoba.nazev_osoby }}</router-link>
                  </td>
                  <td v-else>--</td>
                  <td>{{props.item.bank_nazev_uctu}}</td>
                  <td v-if="props.item.sparovano == 0">Nespárováno</td>
                  <td v-else>Spárováno</td>
                  <td class="text-right">
                    <div>
                      <v-layout row>
                        <v-flex d-flex v-if="props.item.sparovano == 0">
                          <v-btn color="green" dark class="elevation-0 mt-2" @click="pairClick(props.item)">
                          <v-icon small class="mr-2">link</v-icon> Spárovat</v-btn>
                        </v-flex>
                        <v-flex d-flex v-if="props.item.sparovano == 0">
                          <v-btn color="red" dark class="elevation-0 mt-2" @click="returnPaymentClick(props.item)">
                          <v-icon small class="mr-2">replay</v-icon> Vrátit platbu</v-btn>
                        </v-flex>
                        <v-flex right>
                          <v-layout row>
                            <v-flex grow class="text-xs-right" v-if="props.item.sparovano == 1">
                              <v-tooltip bottom>
                                <v-btn color="white" class="elevation-0 text-xs-center" fab small slot="activator" @click="pairClick(props.item)"><v-icon>refresh</v-icon></v-btn>
                                Znovu spárovat
                              </v-tooltip>
                            </v-flex>
                            <v-flex shrink>
                              <v-tooltip bottom>
                                <v-btn color="white" class="elevation-0 text-xs-center" fab small slot="activator" @click="removePaymentClick(props.item)"><v-icon>delete</v-icon></v-btn>
                                Smazat platbu
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <!--<v-btn v-else color="primary" class="elevation-0" @click="item = props.item;dialogDetail=true">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Zrušit spárování</v-btn>-->
                    </div>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      dialogDetail: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Datum a čas', value: 'datum' },
        { text: 'Částka', value: 'castka', width: 130, align: 'right' },
        { text: 'Variabilní symbol', value: 'variabilni_symbol' },
        { text: 'Protiúčet', value: 'protiucet' },
        { text: 'Zpráva pro příjemce', value: 'poznamka' },
        { text: 'Klient', value: 'osoba' },
        { text: 'Název účtu', value: 'bank_nazev_uctu', sortable: false },
        { text: 'Stav', value: 'zpracovano' },
        { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      items: [],
      item: {},
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      dialogReturnPayment: false,
      returningPayment: false,
      pairHeaders: [
        { text: '', value: 'id', sortable: false, width: 30 },
        { text: 'Název osoby', value: 'nazev_osoby', sortable: false },
        { text: 'Typ osoby', value: 'id', sortable: false },
        { text: 'Důvod návrhu', value: 'duvod', sortable: false }
      ],
      pairHeadersSporeni: [
        { text: 'Název spoření', value: 'nazev_sporeni', sortable: false },
        { text: 'Variabilní symbol', value: 'variabilni_symbol', sortable: false },
        { text: 'Stav spoření', value: 'stav_sporeni', sortable: false },
        { text: 'Měna', value: 'mena', sortable: false },
        { text: '', value: 'id', sortable: false }
      ],
      pairHeadersObjednavky: [
        { text: 'Číslo nákupu', value: 'cislo_nakupu', sortable: false },
        { text: 'Stav objednávky', value: 'stav_objednavky', sortable: false },
        { text: 'Částka celkem', value: 'castka_celkem', sortable: false },
        { text: '', value: 'id', sortable: false }
      ],
      pairHeadersPenezenky: [
        { text: 'Měna peněženky', value: 'cislo_nakupu', sortable: false },
        { text: 'Aktuální zůstatek', value: 'stav_objednavky', sortable: false },
        { text: '', value: 'id', sortable: false }
      ],
      pairItems: [],
      searchingPair: false,
      pairOsoba: null,
      dialogRemovePayment: false,
      removingPayment: false,
      stav_platby: 0
    }
  },
  watch: {
    pagination: {
      deep: true,
      handler (v) {
        this.load();
      }
    },
    pairOsoba () {
      this.searchPair();
    },
    stav_platby () {
      this.load();
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function(f) {
      this.counter++;
      this.loadingTable = true;
      var typ_platby = null;
      if (this.stav_platby == 1)
        typ_platby = "sparovano";
      else if (this.stav_platby == 2)
        typ_platby = "nesparovano";
      window.API.post("platby/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        typ_platby: typ_platby
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    returnPaymentClick(v) {
      this.item = v;
      this.dialogReturnPayment = true;
    },
    returnPayment () {
      this.returningPayment = true;
      window.API.get("platby/"+this.item.id+"/vratit-platbu").then(function(body) {
        if (body.status) {
          this.items.splice(this.items.indexOf(this.item), 1);
          this.load(() => {
            this.returningPayment = false;
            this.dialogReturnPayment = false;
          });
        }
        else
          this.returningPayment = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.returningPayment = false;
      }.bind(this));
    },
    pairClick (v) {
      this.item = v;
      this.pairOsoba = null;
      this.dialogDetail = true;
      this.searchingPair = true;
      this.searchPair();
    },
    searchPair () {
      if (this.pairOsoba == null) {
        window.API.get("platby/"+this.item.id+"/najit-osobu").then(function(body) {
          this.pairItems = body;
          this.searchingPair = false;
          this.$nextTick(() => {
            for (let i = 0; i < this.pairItems.length; i += 1) {
                const item = this.pairItems[i];
                this.$set(this.$refs.pairItemsTable.expanded, item.id, this.item);
            }
          });
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.searchingPair = false;
        }.bind(this));
      }
      else {
        window.API.get("platby/"+this.item.id+"/osoba/"+this.pairOsoba.toString()).then(function(body) {
          this.pairItems = body;
          this.searchingPair = false;
          this.$nextTick(() => {
            for (let i = 0; i < this.pairItems.length; i += 1) {
                const item = this.pairItems[i];
                this.$set(this.$refs.pairItemsTable.expanded, item.id, this.item);
            }
          });
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.searchingPair = false;
        }.bind(this));
      }
    },
    makePair (_osoba_id, _typ, _id) {
      this.searchingPair = true;
      window.API.post("platby/"+this.item.id+"/sparovat", {
        osoba: _osoba_id,
        typ: _typ,
        id: _id
      }).then(function(body) {
        if (body.status) {
          this.ok("Spárováno");
          this.load(() => {
            this.searchingPair = false;
            this.dialogDetail = false;
          });
        }
        else {
          this.searchingPair = false;
          this.error("Nebylo spárováno");
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.searchingPair = false;
        this.error("Nebylo spárováno");
      }.bind(this));
    },
    removePaymentClick (v) {
      this.item = v;
      this.dialogRemovePayment = true;
    },
    removePayment () {
      this.removingPayment = true;
      window.API.get("platby/"+this.item.id+"/smazat-platbu").then(function(body) {
        if (body.status) {
          this.items.splice(this.items.indexOf(this.item), 1);
          this.load(() => {
            this.removingPayment = false;
            this.dialogRemovePayment = false;
          });
        }
        else
          this.removingPayment = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.removingPayment = false;
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Platby/BankovniVypis.vue